import { LOCATION_ALTERNATIVES_ROUTES } from './location-alternatives';
import { MATERIALS_AND_EQUIPMENTS_REQUESTS_ROUTES } from './materials-and-equipments-requests';
import { MATERIALS_AND_EQUIPMENTS_TRANSFER_ROUTES } from './materials-and-equipments-transfer';
import { COMPU_MEETING_COORDINATION_ROUTES } from './compu-meeting-coordination';
import { COMPU_MINUTES_EDITOR_ROUTES } from './compu-minutes-editor';
import VOCATIONAL_REHABILITATION_REFERRAL from './vocational-rehabilitation-referral';

export default [
  {
    path: 'pei',
    name: 'pei-menu',
    component: () => import('@/views/Pei.vue'),
    children: [
      {
        path: '/pei',
        name: 'pei',
        component: () => import('@/components/pei/Menu.vue'),
        meta: { IsParent: true },
      },
      {
        path: '/pei/amendment',
        name: 'amendment',
        component: () => import('@/components/pei/amendment/View.vue'),
      },
      {
        path: '/pei/ref/search',
        name: 'peiRefSearch',
        component: () => import('@/components/pei/ref/Search.vue'),
      },
      {
        path: '/pei/ref/intervention-plan/:planId/:admissionId',
        name: 'peiRefInterventionPlan',
        component: () =>
          import('@/components/pei/ref/InterventionPlan/View.vue'),
      },
      {
        path: '/pei/history',
        name: 'studentHistory',
        component: () => import('@/components/pei/History'),
      },
      {
        path: '/pei/documents',
        name: 'peiDocuments',
        component: () => import('@/components/pei/Documents'),
      },
      {
        path: '/pei/controversy/document',
        name: 'peiControversyDocuments',
        component: () => import('@/components/pei/controversy/Document.vue'),
      },
      {
        path: '/pei/detail',
        name: 'peiDetail',
        component: () => import('@/components/pei/Detail.vue'),
      },
      {
        path: '/pei/ref/ProvisionalRemedyRequest',
        name: 'ProvisionalRemedyRequest',
        component: () =>
          import('@/components/pei/ref/ProvisionalRemedyRequest.vue'),
      },
      {
        path: '/pei/detail/unilaterallocations',
        name: 'peiUnilateralLocation',
        component: () =>
          import(
            '@/components/pei/tabs/components/tab8/UnilateralLocations.vue'
          ),
      },
      {
        path: '/pei/addprogramservice',
        name: 'addprogramservice',
        component: () =>
          import('@/components/pei/programservice/AddProgramService.vue'),
      },
      {
        path: '/pei/collationsheet',
        name: 'peiCollationSheet',
        component: () => import('@/components/pei/CollationSheet.vue'),
      },
      {
        path: '/pei/QuestionnaireAEE',
        name: 'QuestionnaireAEE',
        component: () =>
          import('@/components/pei/tabs/components/tab7/QuestionnaireAEE'),
      },
      {
        path: '/pei/evaluations/servicetransition',
        name: 'evaluationServiceTransition',
        component: () =>
          import(
            '@/components/pei/evaluations/servicetransition/ServiceTransition'
          ),
      },
      {
        path: '/pei/evaluations/serviceintervention',
        name: 'peiEvaluationServiceIntervention',
        component: () =>
          import(
            '@/components/pei/evaluations/serviceintervention/ServiceIntervention.vue'
          ),
      },
      {
        path: '/pei/affirmativeletterhistorysearch',
        name: 'affirmativeletterhistorysearch',
        component: () =>
          import('@/components/pei/affirmativeletterhistory/SearchHistory'),
      },
      {
        path: '/pei/affirmativeletterhistoryadd',
        name: 'AffirmativeLetterHistoryadd',
        component: () =>
          import('@/components/pei/affirmativeletterhistory/AddHistory'),
      },
      {
        path: '/pei/affirmativeletterhistoryview/:peiAffirmativeLetterId?',
        name: 'AffirmativeLeeterHistoryView',
        component: () =>
          import('@/components/pei/affirmativeletterhistory/AddHistory'),
      },
      {
        path: '/pei/affirmativeletterhistoryedit/:peiAffirmativeLetterId?',
        name: 'AffirmativeLeeterHistoryEdit',
        component: () =>
          import('@/components/pei/affirmativeletterhistory/AddHistory'),
      },
      {
        path: '/pei/service',
        name: 'Service',
        component: () => import('@/components/pei/service/Service'),
      },
      {
        path: '/pei/controversy/:mode?',
        name: 'Controversy',
        component: () => import('@/components/pei/controversy/Controversy'),
      },
      {
        path: '/pei/searchlocation',
        name: 'SearchLocation',
        component: () => import('@/components/pei/SearchLocation'),
      },
      {
        path: '/pei/availabilityfunds',
        name: 'AvailabilityFunds',
        component: () => import('@/components/pei/AvailabilityFunds'),
      },
      {
        path: '/pei/EvaluationDiscussion',
        name: 'peiEvaluationDiscussion',
        component: () => import('@/components/pei/EvaluationDiscussion.vue'),
      },
      {
        path: '/pei/ServiceHistory',
        name: 'peiServiceHistory',
        component: () =>
          import('@/components/pei/servicehistory/ServiceHistory.vue'),
      },
      {
        path: '/pei/StatusHistory/',
        name: 'pei-status-history',
        component: () =>
          import('@/components/pei/servicehistory/StatusHistory.vue'),
      },
      {
        path:
          '/pei/ServiceHistoryDocuments/:studentServiceId/:allowAddDocument',
        name: 'peiServiceHistoryDocuments',
        component: () =>
          import('@/components/pei/servicehistory/ServiceHistoryDocuments.vue'),
      },
      {
        path: '/pei/ReferralCommentHistory/',
        name: 'referral-comment-history',
        component: () =>
          import('@/components/pei/ref/components/ReferralCommentHistory.vue'),
        props: true,
      },
      {
        path: '/pei/Transportations',
        name: 'peiTransportation',
        component: () =>
          import('@/components/pei/transportationServices/Master.vue'),
      },
      {
        path: '/pei/ref/search',
        name: 'peiReferredManagement',
        component: () => import('@/components/pei/ref/Search.vue'),
      },
      {
        path: '/pei/ref/link',
        name: 'peiReferralLink',
        component: () => import('@/components/pei/ref/Link.vue'),
      },
      {
        path: '/pei/ref/:studentServiceId/record',
        name: 'peiReferralRecord',
        component: () => import('@/components/pei/ref/Record.vue'),
      },
      {
        path: '',
        name: '',
        component: () => import('@/views/pei/compensatoryService/Wrapper.vue'),
        children: [
          {
            path: '/pei/compensatoryservice',
            name: 'Main',
            component: () =>
              import('@/views/pei/compensatoryService/MainWrapper.vue'),
          },
          {
            path: '/pei/compensatoryservice/searchservice',
            name: 'CompensatorySearchService',
            component: () =>
              import(
                '@/views/pei/compensatoryService/SearchServiceWrapper.vue'
              ),
          },
          {
            path: '/pei/compensatoryservice/request',
            name: 'CompensatoryRequest',
            component: () =>
              import('@/views/pei/compensatoryService/RequestWrapper.vue'),
          },
          {
            path: '/pei/compensatoryservice/closinganalysis/:id',
            name: 'ClosingAnalysis',
            component: () =>
              import(
                '@/views/pei/compensatoryService/ClosingAnalysisWrapper.vue'
              ),
          },
        ],
      },
      {
        path: '/pei/ubication-tech-assistance/',
        component: () =>
          import('@/components/pei/ubication-tech-assistance/Wrapper.vue'),
        children: [
          {
            path: 'requests-history',
            name: 'uta-requests-history',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/history-requests/Main.vue'
              ),
          },
          {
            path: 'request/:tapRequestId?',
            name: 'uta-request',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/request/index.vue'
              ),
          },
          {
            path: 'search',
            name: 'uta-search',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/search/index.vue'
              ),
          },
          {
            path: 'validity-request',
            name: 'uta-validity-request',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/validityRequest/index.vue'
              ),
          },
          {
            props: true,
            path: 'management/:tapRequestId',
            name: 'uta-management',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/management/index.vue'
              ),
          },
          {
            props: true,
            path: 'history/:tapRequestId/:studentSIE',
            name: 'uta-history',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/history/index'
              ),
          },
          {
            props: true,
            path: 'observations/:tapRequestId/:studentSIE',
            name: 'uta-observations',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/observations/index'
              ),
          },
          {
            props: true,
            path: 'transfermanagement/:id/:companyId/:academicYearId/:statusId',
            name: 'transfermanagement',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/transfer-management/index'
              ),
          },
          {
            props: true,
            path: 'transferhistory/:tapRequestId',
            name: 'transferhistory',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/transfer-history/index'
              ),
          },
          {
            props: true,
            path: 'amendmenthistory/:tapRequestId/:studentSIE',
            name: 'amendmenthistory',
            component: () =>
              import(
                '@/components/pei/ubication-tech-assistance/amendment-history/index'
              ),
          },
        ],
      },
      {
        path: '/pei/request-tech-assistance-services/:id?',
        name: 'RequestTechAssistanceServices',
        component: () =>
          import(
            '@/views/pei/requestTechAssistanceServices/RequestTechAssistanceServices'
          ),
      },
      {
        path: '',
        component: () => import('@/views/pei/complianceRlv/Wrapper.vue'),
        children: [
          {
            path: '/pei/compliance-rlv',
            name: 'peicompliance-rlv',
            component: () => import('@/views/pei/complianceRlv/Main.vue'),
          },
        ],
      },
      {
        path: '/pei/progress-report-educational-services/',
        component: () =>
          import(
            '@/components/pei/progress-report-educational-services/Wrapper.vue'
          ),
        children: [
          {
            path: '',
            name: 'pres-main',
            component: () =>
              import(
                '@/components/pei/progress-report-educational-services/Main.vue'
              ),
          },
          {
            path: ':onlyPsc/:studentSieId',
            name: 'pres-main-pei',
            component: () =>
              import(
                '@/components/pei/progress-report-educational-services/Main.vue'
              ),
          },
          {
            path:
              ':studentSie/educational-services-program/:academicYear/:week/:onlyPsc/:id?',
            name: 'educational-services-program',
            component: () =>
              import(
                '@/components/pei/progress-report-educational-services/educational-services-program/Main.vue'
              ),
          },
        ],
      },
      {
        path: '/pei/transition-student/',
        component: () =>
          import('@/components/pei/transition-student/Wrapper.vue'),
        children: [
          {
            path: '',
            name: 'main',
            component: () =>
              import('@/components/pei/transition-student/Main.vue'),
          },
          {
            path: 'transition-student-12b/:academicYearId/:id?/',
            name: 'transition-student-12b',
            component: () =>
              import(
                '@/components/pei/transition-student/components/SAEE12B/AddActivity.vue'
              ),
          },
          {
            path: ':peiId/saee-12a/:id?',
            name: 'transition-student-saee-12a',
            component: () =>
              import('@/components/pei/transition-student/saee-12a/Main.vue'),
          },
          {
            path: 'saee-12/:id',
            name: 'transition-student-saee-12',
            component: () =>
              import('@/components/pei/transition-student/saee-12/Main.vue'),
          },
          {
            path: 'saee-12/add',
            name: 'transition-student-saee-12-add',
            component: () =>
              import(
                '@/components/pei/transition-student/saee-12/components/AddStudent.vue'
              ),
          },
        ],
      },
      {
        path: '/pei/visit-registry',
        component: () => import('@/components/pei/visit-registry/Wrapper.vue'),
        children: [
          {
            path: '',
            name: 'main',
            component: () => import('@/components/pei/visit-registry/Main.vue'),
          },
          {
            path: 'visit-registration',
            name: 'visit-registration',
            component: () =>
              import('@/components/pei/visit-registry/Registration.vue'),
          },
        ],
      },
      {
        path: '/pei/materials-and-equipments',
        component: () =>
          import('@/components/pei/materials-and-equipments/Wrapper.vue'),
        children: [
          {
            path: '',
            name: 'materials-and-equipments',
            component: () =>
              import('@/components/pei/materials-and-equipments/Main.vue'),
          },
          {
            path: 'materials-and-equipments/catalog/:id',
            name: 'materials-and-equipments-catalog-management',
            component: () =>
              import(
                '@/components/pei/materials-and-equipments/Management/Main.vue'
              ),
          },
          {
            path: 'materials-and-equipments/catalog/:id/load',
            name: 'materials-and-equipments-load',
            component: () =>
              import('@/components/pei/materials-and-equipments/Load/Main.vue'),
          },
          {
            path: 'materials-and-equipments/catalog/:id/details/:materialId',
            name: 'InventoryMaterialDetails',
            component: () =>
              import(
                '@/components/pei/materials-and-equipments/details/Main.vue'
              ),
          },
          {
            path: 'request/:id/inventory',
            name: 'materials-and-equipments-request-inventory',
            component: () =>
              import(
                '@/views/pei/inventoryRequestsMaterialsAndEquipments/Wrapper'
              ),
            children: [
              {
                path: '',
                name: 'inventoryRequestsMaterialsAndEquipments',
                component: () =>
                  import(
                    '@/views/pei/inventoryRequestsMaterialsAndEquipments/Main'
                  ),
              },
            ],
          },
        ],
      },
      {
        path: '/pei/materials-and-equipments-requests-manage',
        component: () =>
          import('@/views/pei/material-request-management/Wrapper.vue'),
        children: [
          {
            path: '',
            name: 'materials-and-equipments-requests-manage',
            component: () =>
              import('@/views/pei/material-request-management/Main.vue'),
          },
        ],
      },
      ...LOCATION_ALTERNATIVES_ROUTES,
      ...MATERIALS_AND_EQUIPMENTS_REQUESTS_ROUTES,
      ...MATERIALS_AND_EQUIPMENTS_TRANSFER_ROUTES,
      ...COMPU_MEETING_COORDINATION_ROUTES,
      ...COMPU_MINUTES_EDITOR_ROUTES,
      ...VOCATIONAL_REHABILITATION_REFERRAL,
    ],
  },
];
